import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

export function LangRedirect() {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const hasOfferReservation = searchParams.get('offer-reservation');
  const hasOfferPackage = searchParams.get('offer-package');
  const notrack = searchParams.get('notrack');
  const hasTreatments = searchParams.get('treatment');
  const hasRooms = searchParams.get('room');
  const hasCode = searchParams.get('code');

  let path = '';

  if (Array.from(searchParams.keys()).includes('voucher')) {
    path += `/voucher`;
  }
  if (Array.from(searchParams.keys()).includes('reservation')) {
    path += `/reservation`;
  }
  if (Array.from(searchParams.keys()).includes('anfrage-sitaram')) {
    path += `/anfrage-sitaram`;
  }

  const nextSearchParams = new URLSearchParams();

  if (hasOfferPackage) {
    path += `/offer-package`;
    nextSearchParams.set('offer-package', hasOfferPackage);
  }

  if (hasOfferReservation) {
    path += `/offer-reservation`;
    nextSearchParams.set('offer-reservation', hasOfferReservation);
  }

  if (hasTreatments) {
    nextSearchParams.set('treatment', hasTreatments);
  }

  if (hasRooms) {
    nextSearchParams.set('room', hasRooms);
  }

  if (hasCode) {
    nextSearchParams.set('code', hasCode);
  }

  if (notrack === 'yes') {
    nextSearchParams.set('notrack', 'yes');
  }

  const search = nextSearchParams.toString();

  useEffect(() => {
    navigate(
      {
        pathname: `/${i18n.language}${path}`,
        search: search ? `?${search}` : undefined,
      },
      { replace: true }
    );
  }, []);

  return null;
}

export default LangRedirect;
